import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "react-bootstrap";
import Sticky from "react-stickynode";

// Images
import logo from "../../images/logo.svg";
import logoWhite from "../../images/logo-white.svg";
import { facebookUrl, instagramUrl, tiktokUrl } from "../../utils/constants";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };
  const handleMenuCloseClick = () => {
    setIsMenuOpen(false);
  };
  const toggleSubmenu = (item) => {
    setActiveItem(item === activeItem ? null : item);
  };
  const handleMenuLinkClick = () => {
    if (window.innerWidth <= 991) {
      setIsMenuOpen(false);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth >= 768);
    };

    // Check the screen size on initial render and whenever the window is resized
    handleResize();

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const menuItems = [
    {
      id: "home",
      name: "HEM",
      linkName: "",
    },
    {
      id: "services",
      name: "Tjänster",
      linkName: "#",

      subItems: [
        {
          id: "car-painting",
          displayName: "Lackering",
          linkName: "tjanster/billackering-bilar-kungalv",
        },
        {
          id: "damage-inspection",
          displayName: "Skadebesiktning",
          linkName: "tjanster/skadeverkstad-i-goteborg-kungalv",
        },
        {
          id: "service",
          displayName: "Service",
          linkName: "tjanster/bilverkstad-goteborg-kungalv-kbscenter",
        },
        {
          id: "car-details",
          displayName: "Rekond",
          linkName: "tjanster/rekond-tvatt-kungalv",
        },
      ],
    },
    {
      id: "contact",
      name: "Kontakta Oss",
      linkName: "kontakta-oss",
    },
    {
      id: "about",
      name: "Om Oss",
      linkName: "om-oss",
    },
    {
      id: "faq",
      name: "FAQ's",
      linkName: "vanliga-fragor-bilservice",
    },
  ];

  return (
    <>
      <header className="header header-transparent rs-nav">
        <Sticky enabled={true} className="sticky-header navbar-expand-lg">
          <div className="menu-bar clearfix">
            <div className="container clearfix">
              <div className="menu-logo">
                <Link to="/" className="main-logo">
                  <img
                    src={logoWhite}
                    alt="Kungälv Bilskadecenter White Logo - Rekond, Skadebesiktning, Tvätt, Service, Lackering"
                  />{" "}
                </Link>
                <Link to="/" className="sticky-logo">
                  <img
                    src={logo}
                    alt="Kungälv Bilskadecenter Sticky Logo - Bilservice and Lackering in Kungälv"
                  />
                </Link>
              </div>

              <Navbar.Toggle
                className={`navbar-toggler collapsed menuicon justify-content-end ${
                  isMenuOpen ? "open" : ""
                }`}
                onClick={toggleMenu}
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#menuDropdown"
                aria-controls="menuDropdown"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span></span>
                <span></span>
                <span></span>
              </Navbar.Toggle>

              <div className="secondary-menu">
                <Link to="/kontakta-oss" className="btn btn-primary ms-3">
                  Bokning
                </Link>
              </div>

              <Navbar.Collapse
                className={`menu-links navbar-collapse collapse justify-content-center ${
                  isMenuOpen ? "show" : ""
                }`}
                id="menuDropdown"
              >
                <div className="menu-logo">
                  <Link to="/">
                    <img src={logoWhite} alt="" />
                  </Link>
                </div>

                <ul className="nav navbar-nav">
                  {menuItems.map((item) => (
                    <li
                      key={item.id}
                      className={`${activeItem === item.id ? "open" : ""}`}
                      onClick={() => toggleSubmenu(item.id)}
                    >
                      {item.subItems ? (
                        <Link to="#" onClick={(e) => e.preventDefault()}>
                          {item.name}
                          <i
                            className={`fa fa-chevron-down ${
                              activeItem === item.id ? "rotate" : ""
                            }`}
                          ></i>
                        </Link>
                      ) : (
                        <Link
                          to={`/${item.linkName}`}
                          onClick={handleMenuLinkClick}
                        >
                          {item.name}
                        </Link>
                      )}
                      {(isMobileView || activeItem === item.id) &&
                        item.subItems && (
                          <ul className="sub-menu">
                            {item.subItems.map((subItem) => (
                              <li key={subItem.id}>
                                <Link
                                  to={`/${subItem.linkName}`}
                                  onClick={handleMenuLinkClick}
                                >
                                  <span>{subItem.displayName}</span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        )}
                    </li>
                  ))}
                </ul>

                <ul className="social-media">
                  <li>
                    <a
                      target="_blank"
                      href={instagramUrl}
                      rel="noreferrer"
                      className="btn btn-primary"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href={tiktokUrl}
                      rel="noreferrer"
                      className="btn btn-primary"
                    >
                      <i className="fa-brands fa-tiktok"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      target="_blank"
                      href={facebookUrl}
                      rel="noreferrer"
                      className="btn btn-primary"
                    >
                      <i className="fa-brands fa-facebook"></i>
                    </a>
                  </li>
                  {/* <li>
                    <a target="_blank" href="https://youtube.com/" rel="noreferrer" className="btn btn-primary">
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </li> */}
                </ul>

                <div
                  className="menu-close"
                  id="menuClose"
                  onClick={handleMenuCloseClick}
                >
                  <i className="ti-close"></i>
                </div>
              </Navbar.Collapse>
            </div>
          </div>
        </Sticky>
      </header>
    </>
  );
};

export default Header;
